import { createGlobalStyle } from "styled-components";
import { FONTS, publicBasePath, rootFontSize } from "./styleUtils";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Stainless-Regular';
    src: url('${publicBasePath}/fonts/Stainless-Regular.woff2') format('woff2'),
      url('${publicBasePath}/fonts/Stainless-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Stainless-Regular';
    src: url('${publicBasePath}/fonts/Stainless-Regular-Italic.woff2') format('woff2'),
      url('${publicBasePath}/fonts/Stainless-Regular-Italic.woff') format('woff');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Stainless-Regular';
    src: url('${publicBasePath}/fonts/Stainless-Bold.woff2') format('woff2'),
      url('${publicBasePath}/fonts/Stainless-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Stainless-Regular';
    src: url('${publicBasePath}/fonts/Stainless-Bold-Italic.woff2') format('woff2'),
      url('${publicBasePath}/fonts/Stainless-Bold-Italic.woff') format('woff');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'Stainless-Regular';
    src: url('${publicBasePath}/fonts/Stainless-Black.woff2') format('woff2'),
      url('${publicBasePath}/fonts/Stainless-Black.woff') format('woff');
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: 'Stainless-Regular';
    src: url('${publicBasePath}/fonts/Stainless-Black-Italic.woff2') format('woff2'),
      url('${publicBasePath}/fonts/Stainless-Black-Italic.woff') format('woff');
    font-weight: 900;
    font-style: italic;
  }

  @font-face {
    font-family: 'BigBill-Oblique';
    src: url('${publicBasePath}/fonts/BigBill-Oblique.woff2') format('woff2'),
      url('${publicBasePath}/fonts/BigBill-Oblique.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  html,
  body {
    font-family: ${FONTS.PRIMARY};
    font-size: ${rootFontSize}px;
  }

  a {
    color: inherit;
  }
`;

export default GlobalStyles;
